import axios from 'axios';
import { IPQMappingContent } from '../../../../../../types/shared/PrequalificationDataEntry';
export default async function resolveTncLink(
    staticLink: IPQMappingContent['staticTermsConditionsLink'],
    programCode: IPQMappingContent['programCode'],
) {

    const authorViewMode = window.location.search.includes('?wcmmode=disabled')
        ? '&wcmmode=disabled'
        : '';
    if (programCode) {
        let termsUrl = '';
        await axios.get(`/services/termfinder?programCode=${programCode}`).then(response => {
            if (response.data !== '' && response.data !== undefined) {
                termsUrl = `${response.data.termsPath}${window.location.port.includes('4502')? '.html':''}?pc=${programCode}${authorViewMode}`;
            } else {
                console.debug('Terms finder returned an empty response');
            }
        }).catch(err => {
            console.error(err);
        });
        return termsUrl;
    }

    if (staticLink) {
        return staticLink;
    }

    return undefined;
}